import type { DetectedField } from '../models/ai-template-builder.model';

export interface SignerStatus {
  signature: DetectedField | null;
  date: DetectedField | null;
  found: boolean;
}

export interface Signers {
  employer: SignerStatus;
  employee: SignerStatus;
  guardian: SignerStatus;
  secondGuardian: SignerStatus;
  /** Guardians the document already signs for. Apply never adds their anchors twice, so the count starts here. */
  guardians: 0 | 1 | 2;
}

/** A signer is found when both the signature and the signing-date anchor are matched, at any confidence. */
export function signerStatus(fields: DetectedField[]): Signers {
  const matching = (variable: string) =>
    fields.find((field) => field.match.type === 'existing' && field.match.variable === variable) ?? null;
  const status = (signer: string): SignerStatus => {
    const signature = matching(`signature_${signer}`);
    const date = matching(`signing_date_${signer}`);

    return { signature, date, found: signature !== null && date !== null };
  };

  const guardian = status('guardian');
  const secondGuardian = status('guardian_2');
  const guardianSlot = guardian.found ? 1 : 0;

  return {
    employer: status('employer'),
    employee: status('employee'),
    guardian,
    secondGuardian,
    guardians: secondGuardian.found ? 2 : guardianSlot,
  };
}
